const projects = [
  {
    title: "WolfJobs Portal",
    tech: "Node.js, Express.js, React.js, MongoDB, TypeScript, REST API, AWS Cloud",
    bullets: [
      "Scalable job portal managing 1,000+ listings and 500+ users using MERN stack.",
      "Deployed on AWS EC2 with S3 for 500+ resumes, CloudWatch for 99% uptime.",
      "Reduced time-to-hire by 25% using a recruiter-driven workflow and TypeScript.",
    ],
    github: "https://github.com/Rohan0212/WolfJobs",
  },
  {
    title: "CampusJobs Review Portal",
    tech: "Python, React.js, Django, MongoDB, AWS Cloud",
    bullets: [
      "Improved engagement by 40% with redesigned UI and secure login features.",
      "Hosted on AWS EC2 with MongoDB + S3 storing 1,000+ discussions/media.",
      "Added advanced review filters by job type, rating, and date.",
    ],
    github: "https://github.com/Rohan0212/CampusJobReview",
  },
  {
    title: "NBA Data Analysis and Prediction",
    tech: "Machine Learning, Python, K-Means, GMM, Linear Regression, ARIMA",
    bullets: [
      "Reduced dataset from 20,000 to 5,500 players using smart preprocessing.",
      "Clustered skillsets using K-Means & GMM, predicted trends with 98.6% accuracy.",
      "Analyzed 20 years of NBA data for skill & performance predictions.",
    ],
    github: "https://github.com/Rohan0212/NBA-Analysis",
  },
  {
    title: "Real-Time Drowsiness Detection System",
    tech: "Machine Learning, Artificial Intelligence, CNN",
    bullets: [
      "Built a real-time detection system using CNN and Haar cascades.",
      "Achieved 95% accuracy in predicting driver fatigue and alerting.",
      "Published as final-year project focused on driver safety.",
    ],
    github:
      "https://github.com/Rohan0212/Realtime-Drowsiness-Detection-System-using-Cnn",
  },
];

export default projects;
